import React, {
  KeyboardEvent as KeyboardSyntheticEvent,
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
} from 'react';

import { useStyles } from './ecp-store.styles';
import { IEcpStoreProps } from './ecp-store.models';
import { StoreInfo } from '../../../common';
import { pushEcpLocatorEvent } from '../../../../utils/analytics/push-ecp-locator-event';
import { EcpLocatorEvent } from '../../../../models/ya-metrica-events';

export const EcpStore = ({
  storeData,
  onStoreSelect,
  storeCode,
  onScrollToStore,
  contentStyles,
  contentPartialStyles,
  titleStyles,
}: IEcpStoreProps): JSX.Element => {
  const classes = useStyles();
  const {
    name,
    rating,
    type,
    distance,
    street,
    openinghours,
    phonenumber,
    code,
    detailedLocation,
  } = storeData;

  const phoneEl = useRef<HTMLAnchorElement>(null);
  const titleEl = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    onScrollToStore(code, titleEl, storeCode);
  }, [storeCode]);

  const handleKeyPress = useCallback((event: KeyboardSyntheticEvent) => {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();

      if (phoneEl.current !== event.target) {
        onStoreSelect(storeData);
        pushEcpLocatorEvent(EcpLocatorEvent.ClinicAddress, code);
      }
    }
  }, [onStoreSelect, code, storeData]);

  const handleClick = useCallback((event: SyntheticEvent) => {
    if (phoneEl.current !== event.target) {
      onStoreSelect(storeData);
      pushEcpLocatorEvent(EcpLocatorEvent.ClinicAddress, code);
    }
  }, [onStoreSelect, code, storeData]);

  const handlePhoneClick = useCallback(() => {
    pushEcpLocatorEvent(EcpLocatorEvent.PhoneCall, code);
  }, [code]);

  return (
    <div
      className={classes.root}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      role="button"
      tabIndex={0}
      data-testid="store"
    >
      <span
        className={classes.arrowRight}
        data-testid="arrow-right-button"
        aria-hidden="true"
      />
      <StoreInfo
        name={name}
        rating={rating}
        type={type}
        distance={distance}
        street={street}
        detailedLocation={detailedLocation}
        phonenumber={phonenumber}
        openinghours={openinghours}
        titleStyles={titleStyles}
        contentStyles={contentStyles}
        contentPartialStyles={contentPartialStyles}
        onPhoneClick={handlePhoneClick}
      />
    </div>
  );
};
